import noisePng from "./noise.png";
import noiseAvif from "./noise@20aq.avif";
import { clsx } from "clsx";
import ReactDOM from "react-dom";

/**
 * Noise overlay that stretches to fill its closest positioned ancestor
 */
export function Noise({
  priority = false,
  scale = 1,
  ...props
}: React.ComponentPropsWithRef<"div"> & { priority?: boolean; scale?: number }) {
  if (priority) {
    ReactDOM.preload(noiseAvif.src, { as: "image", type: "image/avif" });
  }

  return (
    <div
      data-vrt-hide
      {...props}
      className={clsx(
        "tw-absolute tw-inset-0 tw-mix-blend-overlay",
        // fallback for browsers that don't support image-set
        "tw-bg-[image:var(--noise-png)]",
        // finer noise on high-resolution displays
        "tw-bg-[length:calc(256px*var(--noise-scale))] [@media(min-resolution:2x)]:tw-bg-[length:calc(128px*var(--noise-scale))]",
        props.className,
      )}
      style={
        {
          "--noise-scale": scale,
          "--noise-png": `url(${noisePng.src})`,
          imageRendering: "pixelated",
          // browsers that support image-set will use this
          backgroundImage: `image-set(url(${noiseAvif.src}) type('image/avif'), var(--noise-png) type('image/png'))`,
          ...props.style,
        } as React.CSSProperties
      }
    />
  );
}
